module.exports = __webpack_public_path__ + "img/106.c838c7ab.svg";